<!--
  @author:gll
  @time:2019/8/8
  @disc:化工品权限->批量配置弹窗
 -->

<template>
  <el-dialog
    title="批量配置"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <div class="config-wrap">
      <div class="tip">请选择商品</div>
      <div class="chemical-config">
        <div class="search-chemical">
          <search-select
            v-model="selected"
            placeholder="请输入化工品名称"
            type="chemical"
            clearable
            ref="select"></search-select>
          <el-button
            @click="handleAdd"
            icon="el-icon-plus"
            :disabled="!selected"
            class="btn-add"></el-button>
        </div>
        <div class="chemical-tree">
          <el-tree
            class="industry-tree"
            v-loading="loading"
            node-key="id"
            show-checkbox
            :props="{ value: 'id', label: 'categoryName', children: 'levelDtos', disabled: 'disabled' }"
            :data="region"
            ref="tree"
            :default-checked-keys="defaultCheckedData"
            @check-change="handleCheck">
          </el-tree>
        </div>
        <div class="container-tag" v-if="selectedList.length > 0">
          <el-tag
            v-for="item in selectedList"
            :key="item.id"
            closable
            @close="handleRemove(item.id)">
            {{item.name}}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="customer-config">
      <div class="tip">请选择需要批量配置的客户</div>
      <tag-search-select
        v-model="customer"
        type="customer"
        placeholder="请输入客户名称">
      </tag-search-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="saveConfig">保存</el-button>
    </span>
    <el-dialog
      title="再次确认"
      :visible="submitAgainDialog"
      width="400px"
      :append-to-body="true"
      @close="submitAgainDialog = false">
      <div>确定给用户：{{customerString}}配置化工品（{{chemicalString}}）的查看执行价权限吗？</div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../../components/searchSelect/index'
import TagSearchSelect from '../../../../components/tagSearchSelect/index'
export default {
  name: 'configDialog',
  components: { SearchSelect, TagSearchSelect },
  props: ['show', 'info'],
  data () {
    return {
      loading: false,
      visible: this.show,
      selected: '',
      selectedList: [],
      propsFormat: { value: 'id', label: 'categoryName', children: 'children', disabled: 'disabled' },
      checkedData: [],
      region: [],
      customer: [],
      organizationID: '',
      submitAgainDialog: false,
      customerString: '',
      chemicalString: ''
    }
  },
  computed: {
    defaultCheckedData () {
      return this.selectedList.map(item => item.id)
    }
  },
  methods: {
    ...mapActions(['addChemicalPermission', 'allChemicalCategory']),
    handleRemove (id) {
      this.selectedList.forEach((val, index) => {
        if (val.id === id) {
          this.selectedList.splice(index, 1)
        }
      })
    },
    handleAdd () {
      const isExist = this.$lodash.find(this.selectedList, { id: this.selected.id })
      if (isExist) {
        this.$message.error('请勿添加重复化工品！')
        this.selected = ''
      } else {
        this.selectedList.push(this.selected)
      }
    },
    handleCheck (val, checked) {
      const arr = this.$refs.tree.getCheckedNodes(true)
      const arrPro = arr.filter(item => {
        return item.level === 4
      })
      this.selectedList = arrPro.map(item => {
        return {
          id: item.id,
          name: item.categoryName
        }
      })
    },
    saveConfig () {
      if (this.selectedList.length === 0) {
        this.$message.error('请选择商品！')
      } else if (this.customer.length === 0) {
        this.$message.error('请选择需要批量配置的客户！')
      } else {
        this.customerString = (this.customer.map(item => item.name)).join('、')
        this.chemicalString = (this.selectedList.map(item => item.name)).join('、')
        this.submitAgainDialog = true
      }
    },
    async handleSubmit () {
      this.submitAgainDialog = false
      let params = {
        status: 2,
        accountId: this.customer.map(item => item.id),
        itemId: this.selectedList.map(item => item.id)
      }
      let res = await this.addChemicalPermission(params)
      if (res.success) {
        this.visible = false
        this.$message.success('批量配置权限成功！')
      }
    },
    handleClose () {
      this.$emit('update:show', false)
      this.selectedList = []
    }
  },
  watch: {
    show () {
      this.visible = this.show
      this.customer = []
      if (this.visible) {
        this.loading = true
        this.allChemicalCategory().then(res => {
          this.region = res
          this.region.forEach(item => {
            // item.disabled = true
            if (item.levelDtos) {
              item.levelDtos.forEach(item2 => {
                // item2.disabled = true
                if (item2.levelDtos) {
                  item2.levelDtos.forEach(item3 => {
                    // item3.disabled = true
                    if (item3.itemIdNameDtos && item3.itemIdNameDtos.length > 0) {
                      item3.levelDtos = item3.itemIdNameDtos.map(item4 => {
                        return {
                          categoryName: item4.itemName,
                          level: 4,
                          id: item4.itemId
                        }
                      })
                    }
                  })
                }
              })
            }
          })
          this.loading = false
        })
      }
    },
    selectedList (newVal) {
      this.selected = ''
      this.$nextTick(() => {
        this.$refs.select.dataArr = []
        this.$refs.tree.setCheckedKeys(newVal.map(item => item.id))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.config-wrap{
  margin-top: -15px;
}
.container-tag {
  margin-top: 15px;
  margin-left: 10px;
.el-tag {
  margin-right: 15px;
  margin-bottom: 15px;
}
}
.search-chemical{
  .el-button{
    margin-left: 10px;
  }
}
.tip{
  margin-bottom: 10px;
}
.chemical-tree{
  margin-top: 10px;
  max-height: 240px;
  overflow-y: auto;
}
.customer-config{
  margin-top: 20px;
}
</style>
